module.exports = __webpack_public_path__ + "img/course-vp.7c6fa7d.jpg";